import React from 'react';
import { Rocket, PlayArrow } from '@mui/icons-material';

const QuickStart = ({ language }) => {
    const quickStartExamples = {
        javascript: `const { Netikash } = require('@netikash/sdk');

// Initialisation du client
const client = new Netikash({
  clientId: process.env.NETIKASH_CLIENT_ID,
  clientSecret: process.env.NETIKASH_CLIENT_SECRET,
  environment: 'sandbox' // ou 'production'
});

// Création d'un paiement
async function createPayment() {
  try {
    const payment = await client.payments.create({
      amount: 100.50,
      currency: 'USD',
      reference: 'CMD-2024-001',
      redirectUri: 'https://votre-site.com/confirmation'
    });
    
    console.log('Lien de paiement:', payment.paymentUri);
  } catch (error) {
    console.error('Erreur:', error.message);
  }
}`,

        python: `from netikash import Netikash

# Initialisation du client
client = Netikash(
    client_id=os.getenv('NETIKASH_CLIENT_ID'),
    client_secret=os.getenv('NETIKASH_CLIENT_SECRET'),
    environment='sandbox'  # ou 'production'
)

# Création d'un paiement
try:
    payment = client.payments.create(
        amount=100.50,
        currency='USD',
        reference='CMD-2024-001',
        redirect_uri='https://votre-site.com/confirmation'
    )
    print('Lien de paiement:', payment.payment_uri)
except Exception as e:
    print('Erreur:', str(e))`,

        php: `<?php
require_once 'vendor/autoload.php';

use Netikash\\Netikash;

// Initialisation du client
$client = new Netikash([
    'client_id' => getenv('NETIKASH_CLIENT_ID'),
    'client_secret' => getenv('NETIKASH_CLIENT_SECRET'),
    'environment' => 'sandbox' // ou 'production'
]);

// Création d'un paiement
try {
    $payment = $client->payments->create([
        'amount' => 100.50,
        'currency' => 'USD',
        'reference' => 'CMD-2024-001',
        'redirect_uri' => 'https://votre-site.com/confirmation'
    ]);
    
    echo 'Lien de paiement: ' . $payment->paymentUri;
} catch (Exception $e) {
    echo 'Erreur: ' . $e->getMessage();
}
?>`
    };

    const currentExample = quickStartExamples[language] || quickStartExamples.javascript;

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center space-x-3 mb-4">
                <Rocket className="text-amber-600 text-2xl" />
                <h3 className="text-xl font-semibold text-gray-900">Démarrage Rapide</h3>
            </div>

            <p className="text-gray-600 mb-6">
                Commencez en 5 minutes avec cet exemple de création de paiement.
            </p>

            <div className="bg-gray-900 rounded-lg p-4 mb-6">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-400 text-sm">{language}</span>
                    <button className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm">
                        <PlayArrow className="text-base" />
                        <span>Tester</span>
                    </button>
                </div>
                <pre className="text-green-400 text-sm overflow-x-auto">
          <code>{currentExample}</code>
        </pre>
            </div>

            <div className="grid md:grid-cols-2 gap-4 text-sm">
                <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-medium text-blue-900 mb-2">Configuration Requise</h4>
                    <ul className="text-blue-800 space-y-1">
                        <li>• Clés API Netikash</li>
                        <li>• Variables d'environnement</li>
                        <li>• Connexion Internet</li>
                    </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-medium text-green-900 mb-2">Prochaines Étapes</h4>
                    <ul className="text-green-800 space-y-1">
                        <li>• Vérification des paiements</li>
                        <li>• Gestion des webhooks</li>
                        <li>• Gestion des erreurs</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default QuickStart;